<template>
  <div
    v-if="localValue"
    v-lazy-background="getAssetUrl(image)"
    class="relative z-40 rounded-md p-6"
    :class="{ 'bg-contain': image }"
  >
    <div ref="popup" class="rounded-md">
      <span class="absolute right-0 top-0">
        <button class="p-3" aria-label="Close" @click="closePopup">
          <UiIcon icon="close" class="h-4 w-4" />
        </button>
      </span>

      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useMediaAsset } from '~/composables';

interface Props {
  modelValue?: boolean;
  image?: string;
}
interface Emits {
  (e: 'update:modelValue', data: Props['modelValue']): void;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  image: undefined,
});

const emit = defineEmits<Emits>();

const { getAssetUrl } = useMediaAsset();

const popup = ref(null);
const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

const closePopup = () => (localValue.value = false);

onClickOutside(popup as any, () => closePopup());
</script>
